import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Link from '@material-ui/core/Link';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useDeepCompareEffect } from 'react-use';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import FilterIcon from "assets/images/filter.svg";
import Filters from 'components/common/Filters/index';
import { getLAOFilterArgs } from 'helpers/laoHelpers';
import useSetQuery from 'customHooks/useQuery';
import { LaoFilterChips } from './LaoFilterBox';
import { createFilterObjFromPayload } from 'helpers/emeaHelpers';
import { saveFilters } from 'reduxLib/services';
import { laoImportFilters } from 'reduxLib/constdata/filters';


const useStyles = makeStyles(theme => ({
    rootContainer: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        justifyContent: 'space-between',
        borderRadius: theme.spacing(1),
        background: theme.palette.card.default
    },
    textlink: {
        textAlign: 'center',
        padding: theme.spacing(3),
        cursor: 'pointer',
    }
}));

const LaoFilterHeader = (props) => {

    const {
        filterType,
        type,
        subtype,
        clearAllFilters,
        filterExclusionArray,
        searchText,
        defaultFilters 
    } = props;

    const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobileLao = useMediaQuery(useTheme().breakpoints.down('sm'));
    const [params, setParams] = useSetQuery();

    const [open, setOpen] = useState(false);
    const [laoRemappedFilters, setLaoRemappedFilters] = useState({});

    const handleOpenTableFilters = useCallback(() => {
        setOpen((prev) => !prev);
    }, [open]);

    const customSaveFilters = (savePayload) => {
        const args = getLAOFilterArgs(savePayload.filter);
        setParams({
            key: "laoFilters",
            value: {
                ...params.laoFilters,
                ...args
            }
        })
    }

    const deleteChip = (chip) => {
        const updatedobject = () => {
            return params.laoFilters?.[chip.key]?.filter(d => d !== chip.value);
        }
        setParams({
            key: "laoFilters",
            value: {
                ...params.laoFilters,
                [chip.key]: chip.type === "checkbox" ? updatedobject() : undefined
            }
        });
    }

    useDeepCompareEffect(() => {
        const remappedObject = createFilterObjFromPayload({
            filterPaylod: params?.laoFilters,
            filterBody: defaultFilters,
        });
        setLaoRemappedFilters(remappedObject);
        dispatch(saveFilters({
            filter: {
                ...defaultFilters,
                ...remappedObject
            },
            type,
            subtype
        }));
    }, [params?.laoFilters]); // Store is reset as per url whenever filters or tabs are changed

    // hide filter when tab changes
    useEffect(() => {
        setOpen(false)
    }, [filterType])

    return (
        <>
            <Grid container data-testid="lao-filter-header" className={classes.rootContainer} >
                <Grid item s={12} md={10} >
                    <LaoFilterChips
                        type={type}
                        subtype={subtype}
                        filterBody={defaultFilters}
                        laoDeleteChip={deleteChip}
                        laoRemappedFilters={laoRemappedFilters}
                    />
                </Grid>
                <Grid item s={12} md={1} className={classes.textlink} >
                    {!isEmpty(params.laoFilters) && <Link onClick={clearAllFilters} data-testid="clearLaofilters-kpi"> {t('clear_all')} </Link>}
                </Grid>
                <Grid item s={12} md={1} >
                    <Box textAlign='center'>
                        <IconButton data-testid="laoFilters-kpi"
                            onClick={handleOpenTableFilters}>
                            <img src={FilterIcon} alt="Filter" />
                        </IconButton>
                        {!isMobileLao && <Typography variant='body2' data-testid="filters-kpi"> {t('filters')} </Typography>}
                    </Box>
                    <Filters
                        filtertype={filterType}
                        open={open}
                        handleOpen={handleOpenTableFilters}
                        type={type}
                        subtype={subtype}
                        customSaveFilters={customSaveFilters}
                        clearAllFilters={clearAllFilters}
                        exclude={filterExclusionArray}
                        searchText={searchText}
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default LaoFilterHeader